import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {isIE11} from '../../helpers/ie.helper';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: ${p => p.theme.sideBasket.item.margin};
`;

export const ItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  font-size: ${p => p.theme.sideBasket.item.fontSize};
  ${isIE11() && `
    display: block;
  `};
`;

export const ItemDetails = styled.div`
  color: ${p => p.theme.sideBasket.color};
  font-family: ${p => p.theme.sideBasket.option.fontFamily};
  font-weight: ${p => p.theme.sideBasket.option.fontWeight};
  line-height: ${p => p.theme.sideBasket.option.lineHeight};
  display: flex;
  flex-grow: 1;
  padding-right: ${p => p.theme.sideBasket.item.padding};
  justify-content: space-between;
  ${media.small`
    color: ${props => props.theme.primaryColor};
  `};
  ${isIE11() && `
    max-width: 100%;
    display: block
  `}
`;

export const Remove = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${p => p.theme.button.x.borderRadius};
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: bold;
  text-align: center;
  padding: 0;
  border-bottom: ${props => props.theme.button.x.borderBottom};
  color: ${p => p.theme.button.x.color};
  background-color: ${props => props.theme.button.x.backgroundColor};
  min-width: ${props => props.theme.button.size};
  height: ${props => props.theme.button.size};
  margin-bottom: ${props => props.theme.button.x.margin};
  margin-left: ${props => props.theme.button.x.margin};
  line-height: ${props => props.theme.button.size};
  &:hover {
    background-color: ${props => props.theme.button.x.hoverColor};
  }
`;

export const ItemGroup = styled.div`
  flex-grow: 1;
`;

export const Add = Remove.extend`
  cursor: pointer;
  color: ${props => props.theme.button.plus.color};
  background-color: ${props => props.theme.button.plus.backgroundColor};
  border-bottom-color: ${props => props.theme.button.plus.borderBottom};
  &:hover {
    color: ${props => props.theme.primaryColor};
    background-color: ${props => props.theme.button.plus.hoverColor};
  }
`;

export const EditLink = styled.a`
  cursor: pointer;
  color: ${p => p.theme.tertiaryColor};
  font-size: ${p => p.theme.sideBasket.special.fontSize};
  letter-spacing: ${p => p.theme.sideBasket.special.letterSpacing};
  text-transform: ${p => p.theme.sideBasket.special.textTransform};
  margin-left: ${p => p.hasComment ? p.theme.margin : p.theme.sideBasket.option.margin};
`;

export const Comments = styled.div`
  color: ${p => p.theme.sideBasket.comments.color};
  font-size: ${p => p.theme.sideBasket.option.fontSize};
  margin-left: ${p => p.theme.sideBasket.option.margin};
  line-height: ${p => p.theme.sideBasket.option.lineHeight};
`;

export const Buttons = styled.span`
  position: ${p => p.theme.sideBasket.plusMinus.position};
  display: ${p => p.theme.sideBasket.plusMinus.display};
  right: 0;
  top: ${p => p.theme.sideBasket.plusMinus.top};
  visibility: ${props => props.hideButtons ? 'hidden' : 'visible'};
`;

export const ItemOption = styled.span`
  display: block;
  color: ${props => props.theme.quaternaryColor};
  font-size: ${props => props.theme.sideBasket.option.fontSize};
  margin-left: ${props => props.theme.sideBasket.option.margin};
  ${media.small`
    color: ${props => props.theme.sideBasket.option.color};
  `};
`;



// WEBPACK FOOTER //
// ./components/BasketBar/BasketBarItem.style.js